import { testListConstants } from "../_redux-constants";

export function testListReducer(
  state = {
    testListLoading: false,
    testListData: null,
    testListError: null,
  },
  action
) {
  switch (action.type) {
    case testListConstants.TEST_LIST_LOADING:
      return Object.assign({}, state, {
        testListLoading: true,
        testListData: null,
        testListError: null,
      });
    case testListConstants.TEST_LIST_SUCCESS:
      return Object.assign({}, state, {
        testListLoading: false,
        testListData: action.data,
      });
    case testListConstants.TEST_LIST_FAILURE:
      return Object.assign({}, state, {
        testListLoading: false,
        testListData: null,
        testListError: action.error,
      });
    default:
      return state;
  }
}
